import * as React from 'react';
import Collapsible from 'react-collapsible';
import '../../misc/Collapsible.scss';
import { FileViewModel, QueryOfFileViewModel, Role, WebPortalClient } from 'webportalclient';
import { MappedServerDirectoryCollapse } from '../DirectoryVisualizer';
import { Column, Table } from "../../Components/QueryTable";
import { Authorization } from '../../misc/components/Authorization';
import { PermissionEnum } from '../../misc/api/ApiPermissionEnum';
import { useCurrentStudyConfigurationContext } from '../../Core/CurrentStudyConfigurationContext';
import { useSecurityContext } from '../../Core/SecurityContext';
import { MatchSortHeader } from '../../Components/MatchSortHeader';
import { ODataParams, Query, useQuery } from '../../Components/Query';
import { DateMatchSortHeader } from '../../Components/DateMatchSortHeader';
import { formatDateTime } from '../../misc/components/Formatters/Formatters';
import { useWebPortalApiClient } from '../../misc/api/WebPortalTokenClient';
import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from '@fortawesome/free-solid-svg-icons';

interface DirectoryTableProps {
    roles: Role[];
    directory: MappedServerDirectoryCollapse;
    handleFileDownload: (path: string) => void;
}

export const DirectoryTable = (props: DirectoryTableProps) => {
    const { currentUserPermissions } = useSecurityContext();
    const { study } = useCurrentStudyConfigurationContext();
    const { data, applyFilters, refresh } = useQuery();

    const [fileNameOption, setfileNameOption] = useState([]);
    const [fileSizeOption, setfileSizeOption] = useState([]);
    const client = useWebPortalApiClient();

    useEffect(() => {

        const getFileData = async (path: string) => {
            const result = await client.client.getDirectoryFiles();
            const filteredItems = result.value.filter(item => item.directoryName === path);

            const fileNames = filteredItems.map(s => ({
                value: s.name,
                label: s.name,
            }))

            const fileSizes = filteredItems.map(s => ({
                value: s.size,
                label: s.size,
            }))

            //Remove duplicate file size items. 
            const seen = {};
            const uniqueFileSize = [];
            fileSizes.forEach(item => {
                if (!seen[item.value]) {
                    uniqueFileSize.push(item);
                    seen[item.value] = true;
                }
            });
            setfileNameOption(fileNames);
            setfileSizeOption(uniqueFileSize);
        }
        getFileData(props.directory.serverDirectory);

    }, [])

    const menuFormatter = (file: FileViewModel) => {
        return (
            <div className="text-center">
                <div className="btn-group" role="group">
                    <button type="button" className="btn btn-primary btn-xs dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <FontAwesomeIcon aria-hidden="true" icon={faBars} />
                    </button>
                    <ul className="dropdown-menu pull-right scrollable-menu" role="menu">
                        <li >
                            <a onClick={() => props.handleFileDownload(file.fullPath)}>Download</a>
                        </li>
                    </ul>
                </div>
            </div>
        );
    };


    return (
        <>
            <div className="panel panel-default">
                <div className="panel-body">
                    <Table data={data} rowKeyField="name">
                        <Column field="name" header={<MatchSortHeader title="Name" field="name" options={fileNameOption} sortField="name" />} formatter={n => n} />
                        <Column field="lastWriteTime" header={<DateMatchSortHeader title="Last Modified (Server Time)" field="lastWriteTime" sortField="lastWriteTime" />} formatter={LastWriteTime => formatDateTime(LastWriteTime)} />
                        <Column field="size" header={<MatchSortHeader title="File Size" field="size" options={fileSizeOption} sortField="length" />} formatter={n => n} />
                        <Column field="" formatter={menuFormatter} />

                    </Table>
                </div>
                <Authorization currentPermissions={currentUserPermissions} studyId={study.id} permissionId={PermissionEnum.MapServerDirectories}>
                    {props.roles.length !== 0 ?
                        <div className="panel-footer">
                            Shared with roles: {props.directory.userRoles.map(ur => props.roles.find(r => r.id === ur).name).join(", ")}
                        </div> : <></>
                    }
                </Authorization>
            </div>
        </>
    )
}
